"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "taormina": {
    "44c41ca8": [{
      "hkey": "2784b82f",
      "slug": "chianchitta-trappitello",
      "name": "Chianchitta-Trappitello",
      "primary": true,
      "skipSearch": false
    }],
    "chianchitta": [{
      "hkey": "2784b82f",
      "slug": "chianchitta-trappitello",
      "name": "Chianchitta-Trappitello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "taormina"
    }],
    "b3f2f73d": [{
      "hkey": "2784b82f",
      "slug": "chianchitta-trappitello",
      "name": "Chianchitta-Trappitello",
      "primary": true,
      "skipSearch": false
    }],
    "trappitello": [{
      "hkey": "2784b82f",
      "slug": "chianchitta-trappitello",
      "name": "Chianchitta-Trappitello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "taormina"
    }]
  }
};
exports["default"] = _default;